import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
    selector: 'app-supplier-invoice-item-row',
    templateUrl: './supplier-invoice-item-row.component.html',
    styleUrls: ['./../base-row.component.scss'],
    standalone: false
})
export class SupplierInvoiceItemRowComponent extends BaseRow {
}
